import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { FullPageSpinner } from 'app/common/daisy/full-page-spinner';
import ToolEditor from '../tool-editor';
import type { ToolRunEditProps } from './tool-edit-run-hook';

export const ToolEditRun = (props: ToolRunEditProps) => {
  const { runEditOpen, closeModal, runEditToolName, hasPendingChanges } = props;

  const loading = false;

  let content: React.ReactNode;
  if (loading) {
    content = <FullPageSpinner />;
  } else {
    content = (
      <div className="flex flex-1 min-h-0">
        <div className="flex-1 flex flex-col">
          <ToolEditor toolName={runEditToolName ?? undefined} />
        </div>
      </div>
    );
  }

  return (
    runEditOpen && (
      <div className="modal modal-open">
        <div className="modal-box max-w-6xl w-11/12 h-5/6 max-h-none flex flex-col relative">
          <IconButton
            size="small"
            onClick={closeModal}
            disabled={hasPendingChanges}
            aria-label="Close"
            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <div className="flex flex-col flex-1 min-h-0">{content}</div>
        </div>
        <div className="modal-backdrop" onClick={closeModal} />
      </div>
    )
  );
};
